import{css}from'glamor';export var container=css({background:'#fff'/*
  position: 'sticky',
  top: 'var(--app-bar-height)',
  */});